import { PayloadAction } from '@reduxjs/toolkit'
import { setSettingsValue } from '../../../components/common/utility/helpers'
import { SettingsState } from '../settings.slice'

export const changeTopNavReducer = (
    state: SettingsState,
    action: PayloadAction<any>
): void => {
    const { payload } = action
    state.topNav.fixed = payload

    setSettingsValue('topNavFixed', state.topNav.fixed)
}
